import { isBrowser } from "../../../common/helpers/env";
import React, { useEffect } from "react";

import { adsenseClientId } from "../../../common/parameters";
import { useAfterHydration } from "../../../common/helpers/afterHydration";

import { adsenseSlots } from "./slots";
import { IProps } from "./interfaces";

const isServer = !isBrowser;
const isTesting = isServer || window.location.host !== "musicators.com";

const isAdsEnabled = !isServer && window.isAdsEnabled === 1;

const AdSense = ({ height, width, slot }: IProps) => {
    // The slot is decided by window.isAdsEnabled and by the host the page is served
    // from, neither of which the server can answer - and whichever way it guessed, the
    // markup would be wrong: hydration does not patch up attributes, so an ad rendered
    // on the server would keep its data-ad-test flag on the live site. It is the ad
    // that has to wait, not the page: nothing else here depends on it.
    const afterHydration = useAfterHydration();
    const returnNull = isServer || !isAdsEnabled || !afterHydration;
    useEffect(() => {
        if (returnNull) return;
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, [returnNull]);
    if (returnNull) return null;

    return (
        <ins
            className="adsbygoogle"
            style={{
                display: "block",
                height,
                width,
                ...(isTesting && {
                    boxShadow: "0 0 3px 0 rgba(0, 0, 0, 0.3)",
                    backgroundColor: "#EEEEEE",
                }),
            }}
            data-ad-client={adsenseClientId}
            data-ad-slot={adsenseSlots[slot]}
            data-full-width-responsive="true"
            {...((isTesting || !isAdsEnabled) && { "data-ad-test": "on" })}
        />
    );
}

export default AdSense;
